/**
 * Distinguishes clinic-staff access from patient-only accounts.
 *
 * Matches how the app already decides staff vs patient:
 * JWT `clinic_memberships` (active rows only, from `custom_access_token_hook`)
 * plus the DB fallback in `auth.tsx`, and `is_platform_admin`.
 * A user who is both staff and a portal patient is treated as staff.
 */

export type StaffAccessDecision = 'staff' | 'patient_only' | 'pending';

/**
 * In-app patient portal home. Same path as `App.tsx` `/portal` dashboard
 * and `portalNav.ts` (`portal.nav.dashboard`).
 */
export const PATIENT_PORTAL_PATH = '/portal/dashboard';

export function decideStaffAccess(input: {
  isPlatformAdmin: boolean;
  membershipCount: number;
  membershipsResolved: boolean;
}): StaffAccessDecision {
  if (input.isPlatformAdmin || input.membershipCount > 0) {
    return 'staff';
  }
  if (!input.membershipsResolved) {
    return 'pending';
  }
  return 'patient_only';
}
